const CURRENCY_FORMATTER = new Intl.NumberFormat("en-US", {
  currency: "USD",
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  style: "currency",
});

const SHARE_FORMATTER = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 4,
  minimumFractionDigits: 0,
});

export function formatCurrency(value: number): string {
  return CURRENCY_FORMATTER.format(value);
}

export function formatChange(value: number): string {
  const sign = value >= 0 ? "+" : "-";
  return `${sign}${CURRENCY_FORMATTER.format(Math.abs(value))}`;
}

export function formatSignedPercent(value: number): string {
  const sign = value >= 0 ? "+" : "-";
  return `${sign}${Math.abs(value).toFixed(2)}%`;
}

export function formatPositionPercent(value: number): string {
  return `${value.toFixed(1)}%`;
}

export function formatShares(units: number): string {
  return `${SHARE_FORMATTER.format(units)} ${units === 1 ? "share" : "shares"}`;
}
